import { LitElement, html, css, Splide, Swup } from '@hh/global.js'

class ProductDetailsBreadcrumb extends LitElement {
  static properties = {}

  constructor() {
    super()
  }

  connectedCallback() {
    super.connectedCallback()
    this.handleViewMoreButton()
  }

  disconnectedCallback() {
    super.disconnectedCallback()
  }

  handleViewMoreButton() {
    const viewMoreButtonEl = this.querySelector(
      '.js-product-details-breadcrumb-view-btn'
    )
    const breadcrumbItems = this.querySelector(
      '.js-product-details-breadcrumb-items'
    )

    viewMoreButtonEl?.addEventListener('click', (e) => {
      breadcrumbItems.classList.add('show-all')
      e.target.classList.add('hidden')
    })
  }

  render() {
    return html`<slot></slot>`
  }
}

if (typeof customElements.get('product-details-breadcrumb') === 'undefined') {
  customElements.define('product-details-breadcrumb', ProductDetailsBreadcrumb)
}
